import React, { useEffect, useRef } from 'react';
import type { AnimationItem } from 'lottie-web';
import lottie from 'lottie-web/build/player/lottie_light.min.js';

interface LottieProps extends React.ComponentProps<'div'> {
  animationData: any;
}

export const Lottie = ({ animationData, ...props }: LottieProps) => {
  const element = useRef<HTMLDivElement>(null);
  const lottieInstance = React.useRef<AnimationItem | null>(null);

  useEffect(() => {
    if (element.current && lottie) {
      lottieInstance.current = lottie.loadAnimation({
        animationData,
        container: element.current,
      });
    }
    return () => {
      lottieInstance.current?.destroy();
    };
  }, [animationData]);

  return <div {...props} ref={element}></div>;
};
